var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "app-modal",
        {
          staticClass: "modalModelo",
          attrs: { titulo: _vm.titulo, width: 1100 },
          on: {
            closeModal: function($event) {
              return _vm.$emit("closeModal")
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                "validation-observer",
                { ref: "validation", attrs: { tag: "form" } },
                [
                  _vm.modeloLocal.tipoModelo === "Modelo de Título Reurb"
                    ? [
                        _c("div", { staticClass: "campo-filtro-reurb" }, [
                          _c(
                            "div",
                            [
                              _c("p", [_vm._v("Município:")]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "full-width input",
                                  attrs: {
                                    placeholder: "Selecione o município",
                                    disabled: "disabled"
                                  },
                                  model: {
                                    value: _vm.modeloLocal.idMunicipio,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.modeloLocal,
                                        "idMunicipio",
                                        $$v
                                      )
                                    },
                                    expression: "modeloLocal.idMunicipio"
                                  }
                                },
                                _vm._l(_vm.municipiosComSelecionado, function(
                                  municipio
                                ) {
                                  return _c("el-option", {
                                    key: municipio.id,
                                    attrs: {
                                      label: municipio.nome,
                                      value: municipio.id
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "input-reurb" },
                            [
                              _c("p", [_vm._v("Reurb Coletivo:")]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "full-width input",
                                  attrs: {
                                    placeholder: "Selecione o Reurb Coletivo",
                                    disabled: "disabled"
                                  },
                                  model: {
                                    value: _vm.modeloLocal.idReurbColetivo,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.modeloLocal,
                                        "idReurbColetivo",
                                        $$v
                                      )
                                    },
                                    expression: "modeloLocal.idReurbColetivo"
                                  }
                                },
                                _vm._l(
                                  _vm.reurbColetivosComSelecionado,
                                  function(reurb) {
                                    return _c("el-option", {
                                      key: reurb.id,
                                      attrs: {
                                        label:
                                          reurb.numeroProcesso +
                                          " - " +
                                          reurb.nomeRazaoSocialInteressado,
                                        value: reurb.id
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c("p", [_vm._v("Tipo Reurb:")]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "full-width input",
                                  attrs: {
                                    placeholder: "Selecione o tipo",
                                    disabled: "disabled"
                                  },
                                  model: {
                                    value: _vm.modeloLocal.tipoReurb,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.modeloLocal,
                                        "tipoReurb",
                                        $$v
                                      )
                                    },
                                    expression: "modeloLocal.tipoReurb"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "REURB S",
                                      value: "REURB_S"
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "REURB E",
                                      value: "REURB_E"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _c("div", { staticClass: "group mt-1" })
                      ]
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "group" },
                    [
                      _c("p", { staticClass: "required" }, [
                        _vm._v(
                          _vm._s(
                            _vm.modeloLocal.tipoModelo ===
                              "Modelo de Título Reurb"
                              ? "Modelo de Título"
                              : "Despacho"
                          ) + ":"
                        )
                      ]),
                      _c("validation-provider", {
                        attrs: { rules: "required", name: "Texto do modelo" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-editor-texto", {
                                  class: { erro: errors.length },
                                  attrs: { value: _vm.modeloLocal.textoModelo },
                                  on: { onTextChange: _vm.onTextChange }
                                }),
                                errors.length
                                  ? _c(
                                      "span",
                                      { staticClass: "erro-mensagem" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm.modeloLocal.tipoModelo === "Modelo de Título Reurb"
                    ? _c(
                        "div",
                        { staticClass: "group" },
                        [
                          _c("p", [_vm._v("Assinaturas: ")]),
                          _c("app-anexo", {
                            attrs: {
                              files: _vm.imagensAssinaturas,
                              id: "upload-assinaturas-modelo-editar",
                              tipoExibir: "ANEXO_ANALISE",
                              fileType: ["png", "jpg", "jpeg"]
                            },
                            on: {
                              uploadFile: _vm.uploadAssinatura,
                              downloadDocumentoCadastro:
                                _vm.downloadDocumentoCadastro,
                              removeFile: _vm.removeAssinatura
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _c("template", { slot: "footer" }, [
            _c(
              "div",
              { staticClass: "flex-buttons" },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.$emit("closeModal")
                      }
                    }
                  },
                  [
                    _vm._v("Cancelar  "),
                    _c("div", { staticClass: "fa fa-times" })
                  ]
                ),
                _c(
                  "div",
                  [
                    _vm.modelo.tipoModelo === "Modelo de Título Reurb"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              loading: _vm.loadingPrevisualizacao,
                              disabled: _vm.loadingPrevisualizacao
                            },
                            on: {
                              click: function($event) {
                                return _vm.preVisualizar()
                              }
                            }
                          },
                          [
                            _vm._v("Pré-visualizar  "),
                            !_vm.loadingPrevisualizacao
                              ? _c("div", { staticClass: "fa fa-eye" })
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm.modelo.situacao.toUpperCase() !== "FINALIZADO"
                      ? _c("salvar-modelo", {
                          on: {
                            "update:modelValue": function($event) {
                              return _vm.updateModelo($event)
                            }
                          },
                          model: {
                            value: _vm.updateModelo,
                            callback: function($$v) {
                              _vm.updateModelo = $$v
                            },
                            expression: "updateModelo"
                          }
                        })
                      : _vm._e(),
                    _vm.modelo.tipoModelo === "Modelo de Título Reurb"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "success" },
                            on: {
                              click: function($event) {
                                return _vm.updateModelo($event, true)
                              }
                            }
                          },
                          [
                            _vm._v("Finalizar  "),
                            _c("div", { staticClass: "fa fa-check" })
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        2
      ),
      _vm.showModalVisualizarModelo
        ? _c("app-modal-visualizar-modelo", {
            attrs: {
              modelo: Object.assign({}, _vm.modelo, {
                tipoModelo: "Modelo de Título Reurb",
                textoModelo: _vm.textoModeloPrevisualizacao,
                assinaturas: _vm.imagensAssinaturas
              }),
              titulo: "Pré-visualização do Modelo",
              ativaBotaoVoltar: "true"
            },
            on: {
              closeModal: function($event) {
                _vm.showModalVisualizarModelo = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57e958a9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e958a9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppModalEditarModelo.vue
// module id = null
// module chunks = 